import React from 'react';
import PropTypes from 'prop-types';

import { Stack, IconButton, Edit03Icon } from '@metarouter-private/mr-mui';

import useRowsActionsProps from './useRowsActionsProps';
import DeleteTagAction from './DeleteTagAction';

export default function RowsActions({ row }) {
  const { canWrite, onEdit, onDelete } = useRowsActionsProps(row);

  if (!canWrite) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <IconButton size="small" onClick={onEdit} data-test-id="editTag">
        <Edit03Icon />
      </IconButton>
      <DeleteTagAction row={row} onDelete={onDelete} />
    </Stack>
  );
}

RowsActions.propTypes = {
  row: PropTypes.object.isRequired,
};
